"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const nmr_correlation_1 = require("nmr-correlation");
const react_2 = require("react");
const fa_1 = require("react-icons/fa");
const FindUtilities_1 = require("../../../data/utilities/FindUtilities");
const AssignmentsContext_1 = require("../../assignment/AssignmentsContext");
const ChartContext_1 = require("../../context/ChartContext");
const DispatchContext_1 = require("../../context/DispatchContext");
const Select_1 = __importDefault(require("../../elements/Select"));
const ToolTip_1 = __importDefault(require("../../elements/ToolTip/ToolTip"));
const Modal_1 = require("../../elements/popup/Modal");
const DefaultPanelHeader_1 = __importStar(require("../header/DefaultPanelHeader"));
const CorrelationTable_1 = __importDefault(require("./CorrelationTable/CorrelationTable"));
const Overview_1 = __importDefault(require("./Overview"));
const SetMolecularFormulaModal_1 = __importDefault(require("./SetMolecularFormulaModal"));
const SetShiftTolerancesModal_1 = __importDefault(require("./SetShiftTolerancesModal"));
const Utilities_1 = require("./utilities/Utilities");
const panelStyle = (0, react_1.css) `
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100%;
  width: 100%;

  .extra-header-content {
    display: flex;
    width: 100%;

    .overview-container {
      width: 100%;
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .table-view-selection {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 2px;
      white-space: nowrap;

      label {
        font-size: 13px;
      }
    }
  }
`;
function SummaryPanel() {
    const { molecules, correlations: correlationsData, data: spectraData, xDomain, yDomain, displayerMode, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const modal = (0, Modal_1.useModal)();
    const assignmentData = (0, AssignmentsContext_1.useAssignmentData)();
    const [additionalColumnData, setAdditionalColumnData] = (0, react_2.useState)([]);
    const [selectedAdditionalColumnsAtomType, setSelectedAdditionalColumnsAtomType,] = (0, react_2.useState)('H');
    const [showProtonsAsRows, setShowProtonsAsRows] = (0, react_2.useState)(false);
    const [filterIsActive, setFilterIsActive] = (0, react_2.useState)(false);
    const filteredCorrelationsData = (0, react_2.useMemo)(() => {
        const isInView = (correlation) => {
            if (correlation.pseudo === true) {
                return false;
            }
            const atomTypesInView = activeTab
                .split(',')
                .map((tab) => (0, Utilities_1.getAtomType)(tab));
            const factor = 10000;
            const xDomain0 = xDomain[0] * factor;
            const xDomain1 = xDomain[1] * factor;
            const yDomain0 = yDomain[0] * factor;
            const yDomain1 = yDomain[1] * factor;
            if (displayerMode === '1D') {
                const firstLink1D = correlation.link.find((link) => (0, nmr_correlation_1.getLinkDim)(link) === 1);
                if (!firstLink1D) {
                    return false;
                }
                let delta = (0, nmr_correlation_1.getLinkDelta)(firstLink1D);
                if (delta === undefined) {
                    return false;
                }
                delta *= factor;
                const spectrum = (0, FindUtilities_1.findSpectrum)(spectraData, firstLink1D.experimentID, true);
                if (spectrum &&
                    atomTypesInView[0] === correlation.atomType &&
                    delta >= xDomain0 &&
                    delta <= xDomain1) {
                    return true;
                }
                // try to find a link which contains the belonging 2D signal in the spectra in view
                if (correlation.link.some((link) => {
                    const spectrum = (0, FindUtilities_1.findSpectrum)(spectraData, link.experimentID, true);
                    return (0, Utilities_1.findSignalMatch1D)(spectrum, link, factor, xDomain0, xDomain1);
                })) {
                    return true;
                }
            }
            else if (displayerMode === '2D') {
                if (!atomTypesInView.includes(correlation.atomType)) {
                    return false;
                }
                const firstLink2D = correlation.link.find((link) => (0, nmr_correlation_1.getLinkDim)(link) === 2);
                if (!firstLink2D) {
                    return false;
                }
                const spectrum = (0, FindUtilities_1.findSpectrum)(spectraData, firstLink2D.experimentID, true);
                // correlation is represented by a 2D signal
                if ((0, Utilities_1.findSignalMatch2D)(spectrum, firstLink2D, factor, xDomain0, xDomain1, yDomain0, yDomain1)) {
                    return true;
                }
                // try to find a link which contains the belonging 2D signal in the spectra in view
                else if (correlation.link.some((link) => {
                    const spectrum = (0, FindUtilities_1.findSpectrum)(spectraData, link.experimentID, true);
                    return (0, Utilities_1.findSignalMatch2D)(spectrum, link, factor, xDomain0, xDomain1, yDomain0, yDomain1);
                })) {
                    return true;
                }
            }
            // do not show correlation
            return false;
        };
        if (correlationsData) {
            const _values = filterIsActive
                ? correlationsData.values.filter((correlation) => isInView(correlation))
                : correlationsData.values;
            return { ...correlationsData, values: _values };
        }
    }, [
        activeTab,
        correlationsData,
        displayerMode,
        filterIsActive,
        spectraData,
        xDomain,
        yDomain,
    ]);
    const handleOnSetMolecularFormula = (0, react_2.useCallback)((mf) => {
        dispatch({
            type: 'SET_CORRELATIONS_MF',
            payload: {
                mf,
            },
        });
    }, [dispatch]);
    const handleOnSetShiftTolerance = (0, react_2.useCallback)((tolerance) => {
        dispatch({
            type: 'SET_CORRELATIONS_TOLERANCE',
            payload: {
                tolerance,
            },
        });
    }, [dispatch]);
    const showSetMolecularFormulaModal = (0, react_2.useCallback)(() => {
        modal.show((0, jsx_runtime_1.jsx)(SetMolecularFormulaModal_1.default, { onClose: () => modal.close(), onSave: handleOnSetMolecularFormula, molecules: molecules, previousMF: correlationsData.options.mf }));
    }, [correlationsData, handleOnSetMolecularFormula, modal, molecules]);
    const showSetShiftToleranceModal = (0, react_2.useCallback)(() => {
        modal.show((0, jsx_runtime_1.jsx)(SetShiftTolerancesModal_1.default, { onClose: () => modal.close(), onSave: handleOnSetShiftTolerance, previousTolerance: correlationsData.options.tolerance }));
    }, [correlationsData, handleOnSetShiftTolerance, modal]);
    const additionalColumnTypes = (0, react_2.useMemo)(() => {
        const columnTypes = ['H', 'H-H'].concat(correlationsData
            ? correlationsData.values
                .map((correlation) => correlation.atomType)
                .filter((atomType, i, array) => atomType !== 'H' && array.indexOf(atomType) === i)
            : []);
        return columnTypes.map((columnType) => {
            return {
                label: columnType,
                value: columnType,
            };
        });
    }, [correlationsData]);
    (0, react_2.useEffect)(() => {
        const _selectedAdditionalColumnsAtomType = selectedAdditionalColumnsAtomType.split('-')[0];
        setAdditionalColumnData(filteredCorrelationsData
            ? filteredCorrelationsData.values
                .filter((correlation) => correlation.atomType === _selectedAdditionalColumnsAtomType)
                .reverse()
            : []);
    }, [filteredCorrelationsData, selectedAdditionalColumnsAtomType]);
    const editEquivalencesSaveHandler = (0, react_2.useCallback)((correlation, value) => {
        dispatch({
            type: 'SET_CORRELATION',
            payload: {
                id: correlation.id,
                correlation: {
                    ...correlation,
                    equivalence: value,
                    edited: { ...correlation.edited, equivalence: value !== 1 },
                },
            },
        });
    }, [dispatch]);
    const editNumericValuesSaveHandler = (0, react_2.useCallback)(({ correlation, values, key, }) => {
        dispatch({
            type: 'SET_CORRELATION',
            payload: {
                id: correlation.id,
                correlation: {
                    ...correlation,
                    [key]: values,
                    edited: { ...correlation.edited, [key]: true },
                },
                options: {
                    skipDataUpdate: true,
                },
            },
        });
    }, [dispatch]);
    const setCorrelationsHandler = (0, react_2.useCallback)((correlations, options) => {
        dispatch({
            type: 'SET_CORRELATIONS',
            payload: {
                correlations,
                options,
            },
        });
    }, [dispatch]);
    const deleteCorrelationHandler = (0, react_2.useCallback)((correlation) => {
        dispatch({
            type: 'DELETE_CORRELATION',
            payload: {
                correlation,
                assignmentData,
            },
        });
    }, [assignmentData, dispatch]);
    const deleteSignalHandler = (0, react_2.useCallback)((link) => {
        // remove linking signal in spectrum
        const linkDim = (0, nmr_correlation_1.getLinkDim)(link);
        if (linkDim === 1) {
            const spectrum = (0, FindUtilities_1.findSpectrum)(spectraData, link.experimentID, false);
            const range = (0, FindUtilities_1.findRange)(spectrum, link.signal.id);
            const signal = (0, FindUtilities_1.findSignal1D)(spectrum, link.signal.id);
            if (spectrum && range && signal) {
                dispatch({
                    type: 'DELETE_1D_SIGNAL',
                    payload: {
                        spectrum,
                        range,
                        signal,
                        assignmentData,
                    },
                });
            }
        }
        else if (linkDim === 2) {
            const spectrum = (0, FindUtilities_1.findSpectrum)(spectraData, link.experimentID, false);
            const zone = (0, FindUtilities_1.findZone)(spectrum, link.signal.id);
            const signal = (0, FindUtilities_1.findSignal2D)(spectrum, link.signal.id);
            if (zone && signal) {
                dispatch({
                    type: 'DELETE_2D_SIGNAL',
                    payload: {
                        spectrum,
                        zone,
                        signal,
                        assignmentData,
                    },
                });
            }
        }
    }, [assignmentData, dispatch, spectraData]);
    const changeSignalPathLengthHandler = (0, react_2.useCallback)((link) => {
        const linkDim = (0, nmr_correlation_1.getLinkDim)(link);
        if (linkDim === 2) {
            const spectrum = (0, FindUtilities_1.findSpectrum)(spectraData, link.experimentID, false);
            const zone = (0, FindUtilities_1.findZone)(spectrum, link.signal.id);
            const signal = (0, FindUtilities_1.findSignal2D)(spectrum, link.signal.id);
            if (zone && signal) {
                dispatch({
                    type: 'SET_2D_SIGNAL_PATH_LENGTH',
                    payload: {
                        spectrum,
                        zone,
                        signal,
                        pathLength: link.signal.j?.pathLength,
                    },
                });
            }
        }
    }, [dispatch, spectraData]);
    const editCorrelationTableCellHandler = (0, react_2.useCallback)((editedCorrelations, action, link, options) => {
        if (action === 'add' ||
            action === 'move' ||
            action === 'remove' ||
            action === 'unmove' ||
            action === 'setPathLength') {
            if (link && link.pseudo === false) {
                if (action === 'remove') {
                    deleteSignalHandler(link);
                }
                else if (action === 'setPathLength') {
                    changeSignalPathLengthHandler(link);
                }
            }
            setCorrelationsHandler(editedCorrelations, options);
        }
        else if (action === 'removeAll') {
            deleteCorrelationHandler(editedCorrelations[0]);
        }
    }, [
        changeSignalPathLengthHandler,
        deleteCorrelationHandler,
        deleteSignalHandler,
        setCorrelationsHandler,
    ]);
    const handleOnFilter = (0, react_2.useCallback)(() => {
        setFilterIsActive(!filterIsActive);
    }, [filterIsActive]);
    const counter = correlationsData ? correlationsData.values.length : 0;
    return ((0, jsx_runtime_1.jsxs)("div", { css: panelStyle, children: [(0, jsx_runtime_1.jsxs)(DefaultPanelHeader_1.default, { canDelete: false, counter: counter, counterLabel: (0, DefaultPanelHeader_1.createFilterLabel)(counter, filterIsActive && filteredCorrelationsData?.values.length), onFilter: handleOnFilter, filterToolTip: filterIsActive
                    ? 'Show all correlations'
                    : 'Hide correlations out of view', children: [(0, jsx_runtime_1.jsx)(ToolTip_1.default, { title: `Set molecular formula (${correlationsData.options.mf})`, popupPlacement: "right", children: (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: showSetMolecularFormulaModal, children: (0, jsx_runtime_1.jsx)(fa_1.FaFlask, {}) }) }), (0, jsx_runtime_1.jsx)(ToolTip_1.default, { title: `Set shift tolerance`, popupPlacement: "right", children: (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: showSetShiftToleranceModal, children: (0, jsx_runtime_1.jsx)(fa_1.FaSlidersH, {}) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "extra-header-content", children: [(0, jsx_runtime_1.jsx)("div", { className: "overview-container", children: (0, jsx_runtime_1.jsx)(Overview_1.default, { correlationsData: correlationsData }) }), (0, jsx_runtime_1.jsx)("div", { className: "table-view-selection", children: (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("label", { children: "View:" }), (0, jsx_runtime_1.jsx)(Select_1.default, { onChange: (selection) => {
                                                setSelectedAdditionalColumnsAtomType(selection);
                                                if (selection === 'H-H') {
                                                    setShowProtonsAsRows(true);
                                                }
                                                else {
                                                    setShowProtonsAsRows(false);
                                                }
                                            }, items: additionalColumnTypes, defaultValue: selectedAdditionalColumnsAtomType, style: {
                                                fontSize: '12px',
                                                width: '70px',
                                                height: '18px',
                                                border: '1px solid grey',
                                            } })] }) })] })] }), (0, jsx_runtime_1.jsx)(CorrelationTable_1.default, { correlationsData: correlationsData, filteredCorrelationsData: filteredCorrelationsData, additionalColumnData: additionalColumnData, editEquivalencesSaveHandler: editEquivalencesSaveHandler, onSaveEditNumericValues: editNumericValuesSaveHandler, onEditCorrelationTableCellHandler: editCorrelationTableCellHandler, showProtonsAsRows: showProtonsAsRows, spectraData: spectraData })] }));
}
exports.default = (0, react_2.memo)(SummaryPanel);
